import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../setup'
import {useCallback, useEffect} from 'react'

export const useFaviconAndTitle = () => {
    const {favicon, name} = useSelector(
        (state: RootState) => ({
            favicon: state.workspace.images.favicon,
            name: state.workspace.name,
        }),
        shallowEqual,
    )

    const updateFaviconAndTitle = useCallback((faviconUrl: string, newTitle: string) => {
        const link = document.querySelector<HTMLLinkElement>('link[rel~="icon"]') || document.createElement('link')
        link.rel = 'icon'

        if (link.href !== faviconUrl) link.href = faviconUrl
        if (document.title !== newTitle) document.title = newTitle

        if (!document.head.contains(link)) {
            document.head.appendChild(link)
        }
    }, [])

    useEffect(() => {
        updateFaviconAndTitle(favicon, name)
    }, [favicon, name, updateFaviconAndTitle])
}